import { NgModule } from '@angular/core';
import { TranslateWithFallbackPipe } from './translate-with-fallback.pipe';

@NgModule({
  declarations: [TranslateWithFallbackPipe],
  exports: [TranslateWithFallbackPipe],
  providers: [TranslateWithFallbackPipe]
})
export class PipesModule {}
